import { Entity } from '@adornis/baseql/decorators.js';
import type { ColumnDefinitionBase } from '@adornis/data-view/ColumnDefinition.js';
import { ExportDataView } from '@adornis/data-view/db/export-data-view.js';
import type { ILSUserOverviewLine } from '@legacy-db/ils-user-overview-line.js';

@Entity()
export class ILSUserOverviewLineDataView extends ExportDataView {
  static override _class = 'ILSUserOverviewLineDataView';

  static override basicColumnDefinitions = [
    {
      fieldName: 'user.profile.wantsNewsletter',
      getFieldMapping: entityInstance => entityInstance.user.profile?.wantsNewsletter ?? false,
    },
  ] satisfies ColumnDefinitionBase<typeof ILSUserOverviewLine>[];
}
